export class PsMachine {

    _id; // number
    _model; // string
    _brand; // string
    _licensePlate; // string

    constructor(
        id,
        model,
        brand,
        licensePlate,
    ) {
        this._id = id;
        this._model = model;
        this._brand = brand;
        this._licensePlate = licensePlate;
    }

    static fromAPIMachine(machine) {
        return new this(
            machine.id,
            machine.model || '',
            machine.brand || '',
            machine.name || '',
        );
    }

    id() {
        return this._id;
    }

    model() {
        return this._model;
    }

    brand() {
        return this._brand;
    }

    licensePlate() {
        return this._licensePlate;
    }

    shortDescription() {
        return `${this.licensePlate() ? `${this.licensePlate()} - ` : ''}${this.brand()} - ${this.model()}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/document/shared/PsMachine.js